import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild, OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from '../../services/Notifierservice';
import validationform from '../../validation/validationform';
import { SignupService } from './service/signup.service';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  standalone: false,
  selector: 'app-sign-up',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sign-up.component.html',
})
export class SignUpComponent implements OnInit {
  signUpForm: FormGroup = new FormGroup({});
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  storeSignUpForm: any;
  submitted!: boolean;
  spinner: boolean = false;

  countryCode1: any;
  countryCode2: any;
  response: any = [];

  separateDialCode = false;
  selectedCountryCode: any;

  private readonly notifier: NotifierService;
  selectedTranscribe!: number;
  transcribeList = [
    { id: 1, name: 'AWS' },
    { id: 2, name: 'Google' },
    { id: 3, name: 'Canstring AI' },
  ];

  // initContry: any;
  formattedValue: any;
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('intlInput') intlInput!: ElementRef;
  constructor(
    private readonly fb: FormBuilder,
    private readonly notifierService: NotifierService,
    private readonly signUpService: SignupService,
    private readonly config: NgSelectConfig,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.signUpForm = this.fb.group({
      companyname: [
        null,
        [Validators.required, Validators.pattern(/\S/)],
      ],
      location: [
        null,
        [Validators.required, Validators.pattern(/\S/)],
      ],
      username: [
        null,
       [Validators.required, Validators.pattern(/\S/)],
      ],
      transcribe: [3, Validators.required],
      email: [
        null,
        [
          Validators.required,
           Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
        ),
        ],
      ],
      password: [
        null,
        [
          Validators.required,
         Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@!%*?&])[A-Za-z\\d$@!%*?&]{8,12}$',
        ),
        ],
      ],
      phonenumber: ['', [Validators.required]],
      agent: [null],
      terms: [null, [Validators.required, Validators.requiredTrue]],
    });
    this.signUpForm.controls['agent'].setValue(10);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }

  hideShowPassword(): void {
  this.isText = !this.isText;

  this.eyeIcon = this.isText ? 'fa-eye' : 'fa-eye-slash';
  this.type = this.isText ? 'text' : 'password';
}

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  async onSubmit() {
    this.submitted = true;
    this.signUpForm.markAllAsTouched();

    if (!this.signUpForm.valid) {
      validationform.ValidateAllFormFields(this.signUpForm);
      return;
    }

    const value = this.signUpForm.value;
    const email = value.email?.trim();
    const password = value.password;

    try {
      // ── Web Crypto encryption (matches login.component.ts) ──
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const passPhrase = this.makeRandom(16, possible);
      const salt = this.makeRandom(16, possible);
      const enc = new TextEncoder();

      const keyMaterial = await crypto.subtle.importKey(
        'raw',
        enc.encode(passPhrase),
        { name: 'PBKDF2' },
        false,
        ['deriveKey'],
      );

      const aesKey = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: enc.encode(salt),
          iterations: 100_000,
          hash: 'SHA-256',
        },
        keyMaterial,
        { name: 'AES-GCM', length: 256 },
        false,
        ['encrypt'],
      );

      const iv = crypto.getRandomValues(new Uint8Array(12));

      const ciphertextBuffer = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        aesKey,
        enc.encode(password),
      );

      const combined = new Uint8Array(
        iv.byteLength + ciphertextBuffer.byteLength,
      );
      combined.set(iv, 0);
      combined.set(new Uint8Array(ciphertextBuffer), iv.byteLength);

      const encryptedData = btoa(
        Array.from(combined)
          .map((b) => String.fromCharCode(b))
          .join(''),
      );
      // ── End encryption ──

      const formEncript = {
        username: value.username,
        encrypted_data: encryptedData,
        salt: salt,
        pass_phrase: passPhrase,
        email: email,
        first_name: null,
        last_name: null,
        phone_number: value.phonenumber,
        role: 'Admin',
        empid: null,
        location: value.location,
        doj: null,
        company_name: value.companyname,
      };

      this.spinner = true;
      this.signUpService.signUp(formEncript).subscribe({
        next: (response) => {
          localStorage.setItem('loginuser', email);
          this.response = response;
          this.formChange.emit('verify');
          this.notifier.notify(
            'default',
            'Account created successfully. A verification code has been sent to your registered email.',
          );
          this.spinner = false;
        },
        error: (err) => {
          this.spinner = false;
        },
      });
    } catch (error) {
      console.error('Encryption error:', error);
      this.spinner = false;
    }
  }

  returnBack(value: string) {
    this.formChange.emit(value);
  }


  onCountryChange(event: any) {
    this.countryCode2 = event?.dialCode;
  }

  hasError(event: any) {
    // need to implement
  }

  telInputObject(event: any) {
    this.countryCode1 = event.s.dialCode;
  }


  onInputPhoneChange(event: any) {
    if (event.target.value.length > 17) {
      event.preventDefault();
      let input = event.target.value;
      this.formattedValue = input.slice(0, 17);
      this.signUpForm.controls['phonenumber'].setValue(this.formattedValue);
    }
  }
}
